import { 
  Box, 
  Typography, 
  Grid, 
} from '@material-ui/core';
import React from 'react';
import JobsPendingWidget from './Widgets/JobsPendingWidget';
import JobsOverdueWidget from './Widgets/JobsOverdueWidget';
import { RequestGroup } from './hooks/useServiceRequestSearch';

const MissedBinsDashboard = () => {
  return (
    <>
      <Typography variant="h1">Missed Bins</Typography>
      <Box mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <JobsPendingWidget title="Pending Jobs" jobGroup={RequestGroup.MissedBin} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <JobsOverdueWidget title="Overdue Jobs" jobGroup={RequestGroup.MissedBin} />
          </Grid>
        </Grid>        
      </Box>
    </>
  );
}

export default MissedBinsDashboard;